import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

export default function NewsPage() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios.get(`${API}/news`).then((res) => setNews(res.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="news-page">
      <section className="relative py-24" style={{ background: "linear-gradient(135deg, #0A2A43 0%, #0A2A43 50%, #4a1a2a 85%, #6b1f2f 100%)" }}>
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 lg:px-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 font-barlow italic animate-on-load animate-fade-in-down">News</h1>
          <p className="text-white/80 text-lg max-w-2xl mx-auto animate-on-load animate-fade-in-up animation-delay-300">Aktuelle Beiträge, Einblicke und Neuigkeiten von Gashi Bau GmbH.</p>
        </div>
      </section>
      <section className="section-padding bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.map((item) => (
            <article key={item.id} className="border rounded-xl overflow-hidden bg-white shadow-sm" data-testid={`public-news-item-${item.slug}`}>
              {item.image_url && <img src={item.image_url} alt={item.title} className="w-full aspect-[4/3] object-cover" />}
              <div className="p-6">
                <p className="text-sm text-[#D32F2F] mb-2">{new Date(item.date).toLocaleDateString("de-DE")}</p>
                <h2 className="text-2xl font-bold text-[#0A2A43] font-barlow mb-3">{item.title}</h2>
                <p className="text-[#475569] mb-5">{item.short_text}</p>
                <Link to={`/news/${item.slug}`} className="btn-primary inline-flex" data-testid={`public-news-link-${item.slug}`}>Mehr lesen</Link>
              </div>
            </article>
          ))}
          {news.length === 0 && <p className="text-gray-400 col-span-full text-center py-12">Keine News vorhanden</p>}
        </div>
      </section>
    </div>
  );
}
